__turbopack_context__.v({
  "controls": "ydEeuW_controls",
  "controls__navigation": "ydEeuW_controls__navigation",
  "controls__pagination": "ydEeuW_controls__pagination",
  "controls__previous": "ydEeuW_controls__previous",
  "image-gallery": "ydEeuW_image-gallery",
  "image-gallery--dawn": "ydEeuW_image-gallery--dawn",
  "image-gallery--dawn-2": "ydEeuW_image-gallery--dawn-2",
  "image-gallery--dusk": "ydEeuW_image-gallery--dusk",
  "image-gallery--light-dusk": "ydEeuW_image-gallery--light-dusk",
  "image-gallery--midnight": "ydEeuW_image-gallery--midnight",
  "image-gallery--midnight-2": "ydEeuW_image-gallery--midnight-2",
  "image-gallery--warm-red": "ydEeuW_image-gallery--warm-red",
  "image-gallery__body": "ydEeuW_image-gallery__body",
  "image-gallery__heading": "ydEeuW_image-gallery__heading",
  "image-gallery__image": "ydEeuW_image-gallery__image",
  "image-gallery__inner": "ydEeuW_image-gallery__inner",
  "image-gallery__slide": "ydEeuW_image-gallery__slide",
  "image-gallery__swiper": "ydEeuW_image-gallery__swiper",
});
